/* Tire markings for the DFW PDP guide. Unsupported formats fail to generic guidance.
   Sources: pirelli.com/tires/en-us/car/driving-and-tire-tips/how-to-read/tire-load-index
   michelinman.com/auto/auto-tips-and-advice/tire-buying-guide/change-size-spec */
(function (scope) {
  /* Standard load index table, 60–130 (lb per tire). */
  const loads = { 60: 551, 61: 567, 62: 584, 63: 600, 64: 617, 65: 639, 66: 661, 67: 677, 68: 694, 69: 716, 70: 739, 71: 761, 72: 783, 73: 805, 74: 827, 75: 852, 76: 882, 77: 908, 78: 937, 79: 963, 80: 992, 81: 1019, 82: 1047, 83: 1074, 84: 1102, 85: 1135, 86: 1168, 87: 1201, 88: 1235, 89: 1279, 90: 1323, 91: 1356, 92: 1389, 93: 1433, 94: 1477, 95: 1521, 96: 1565, 97: 1609, 98: 1653, 99: 1709, 100: 1764, 101: 1819, 102: 1874, 103: 1929, 104: 1984, 105: 2039, 106: 2094, 107: 2149, 108: 2205, 109: 2271, 110: 2337, 111: 2403, 112: 2469, 113: 2535, 114: 2601, 115: 2679, 116: 2756, 117: 2833, 118: 2910, 119: 2998, 120: 3086, 121: 3197, 122: 3307, 123: 3417, 124: 3527, 125: 3638, 126: 3748, 127: 3858, 128: 3968, 129: 4079, 130: 4189 };
  const speeds = { L: [75, 120], M: [81, 130], N: [87, 140], P: [93, 150], Q: [99, 160], R: [106, 170], S: [112, 180], T: [118, 190], U: [124, 200], H: [130, 210], V: [149, 240], W: [168, 270], Y: [186, 300] };
  const decode = title => {
    const m = /^(LT)?(\d{3})\/(\d{2})R(\d{2}) (\d{2,3})(?:\/(\d{2,3}))?([LMNPQRSTUHVWY])(?: (E))?$/.exec(String(title || '').trim());
    if (!m) return null;
    const [, lt, width, aspect, rim, load, dual, speed, range] = m;
    if (!loads[load] || (dual && (!lt || !loads[dual])) || (range && !lt)) return null;
    const weight = code => loads[code].toLocaleString('en-US') + ' lb per tire';
    const ratings = [
      [dual ? load + '/' + dual : load, 'Load index', dual ? 'Load: ' + weight(load) + ' single, ' + weight(dual).replace(' per tire', '') + ' dual.' : 'Load: ' + weight(load) + '.'],
      [speed, 'Speed rating', 'Speed: ' + speeds[speed][0] + ' mph (' + speeds[speed][1] + ' km/h).']
    ];
    const dimensions = [
      [width, 'Tire width', width + ' mm tire width.'],
      [aspect, 'Sidewall height', 'Sidewall height: ' + aspect + '% of width.'],
      ['R', 'Construction', 'Radial construction.'],
      [rim, 'Wheel diameter', rim + '-inch wheel diameter.']
    ];
    if (lt) dimensions.push(['LT', 'Tire type', 'Light-truck tire.']);
    if (range) dimensions.push([range, 'Load range', 'Load range E (light-truck construction).']);
    return { ratings, dimensions };
  };
  const render = (guide, title) => {
    if (!guide) return;
    const rows = decode(title);
    const previous = guide.dataset.title;
    guide.dataset.title = title || '';
    if (previous !== guide.dataset.title) guide.open = false;
    guide.hidden = !title;
    guide.querySelector('[data-aw-code-title]').textContent = 'Explain size & ratings';
    guide.querySelector('[data-aw-code-fallback]').hidden = !!rows;
    guide.querySelector('[data-aw-code-breakdown]').hidden = !rows;
    ['ratings', 'dimensions'].forEach(group => {
      const list = guide.querySelector('[data-aw-code-' + group + ']');
      list.replaceChildren();
      if (!rows) return;
      rows[group].forEach(([code, , meaning]) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const token = document.createElement('strong');
        token.textContent = code;
        term.append(token);
        const definition = document.createElement('dd');
        definition.textContent = meaning;
        row.append(term, definition); list.append(row);
      });
    });
  };
  scope.AWTireMarkings = { decode, render };
  if (typeof module !== 'undefined' && module.exports) module.exports = scope.AWTireMarkings;
})(typeof window === 'undefined' ? globalThis : window);
